import { useContext, useEffect, useState } from "react";

import ShopInfoEditTable from "../ShopInfoEditTable";
import { CompanyTitledPage } from "../../TitledPage";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { useLocation, useNavigate } from "react-router-dom";

import { SYSTEM_PATH_COMPANY } from "../../../App";
import { CompanyPartHeader } from "../../../components/PartHeader";
import useInputObject from "../../../hooks/useInputObject";
import { insertShopInfo, searchCustomerInfoList } from "../../../http/api/CustomerAPI";
import { ScreenStatusContext } from "../../../context/ScreenStatusContext";
import { confirmWhenChanged } from "../../../utils/validation";

const getCustomerLocationState = (customerId) => ({
  customerId: customerId,
});

const getShopLocationState = (customerId, shopId) => ({
  customerId: customerId,
  shopId: shopId,
});

// 新規店舗登録ページ
export default function ShopRegistrationPage() {
  const location = useLocation();
  const navigate = useNavigate();

  // 取引先情報
  const [customer, setCustomer] = useState({});
  const customerId = location.state.customerId;

  // 登録中をあらわすstate
  const [isRegistering, setRegistering] = useState(false);
  // 画面ステータスをcontextから取得
  const {isChanged} = useContext(ScreenStatusContext);

  //取引先情報を取得
  useEffect(() => {
    GetCustomerInfo();
  }, []);
  async function GetCustomerInfo() {
    let response = await searchCustomerInfoList({ customerId });
    setCustomer(response.listCustomerInfo[0]);
  }

  // 店舗情報
  const shop = useInputObject({
    shopId: "",
    shopName: "",
    shopNameFurigana: "",
    containerQuantity: 0,
    customerId: customerId,
    address: "",
    tel: "",
    fax: "",
    email: "",
    buyerNo: "",
  });

  // 店舗を登録
  const insertShopInfoData = async () => {
    setRegistering(true);

    shop.Value.createdId = 1; //TODO JWTを追加した後削除
    shop.Value.updatedId = 1; //TODO JWTを追加した後削除
    try {
      const newShopId = await insertShopInfo(shop.Value);
      alert("店舗を登録しました。");
      navigate(SYSTEM_PATH_COMPANY + "/shop_information", {
        state: getShopLocationState(customerId, newShopId),
      });
    } catch {
      alert("店舗を登録できなかった。");
    } finally {
      setRegistering(false);
    }
  };

  // 取引先情報画面に戻る
  const onClickReturn = (event) => {
    if (confirmWhenChanged(isChanged)) {
      navigate(SYSTEM_PATH_COMPANY + "/customer_information", {
        state: getCustomerLocationState(customerId),
      });
    }
  };

  // 登録した店舗情報画面に移動する
  const onClickRegister = (event) => {
    const newShopId = insertShopInfoData();
  };

  return (
    <CompanyTitledPage title="新規店舗登録">
      <Typography>取引先ID : {customerId}</Typography>

      {/* 取引先名 */}
      <Typography fontWeight="bold" fontSize={30}>
        {customer.customerName}
      </Typography>

      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              店舗情報の入力
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClickRegister} disabled={isRegistering}>
              登録
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={onClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>

      <ShopInfoEditTable shop={shop} customerName={customer.customerName} />
    </CompanyTitledPage>
  );
}
